import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { AddCollaborator, ChevronRight } from '@/assets/icons'
import { Button } from '@/components/button/Button'

interface AccountMenuViewOrganizationCardProps {
  orgName: string
  memberCount: number
  onViewOrganization: () => void
  /** When provided, renders the "Invite members" link (org admin only) */
  onInviteMembers?: () => void
}

export function AccountMenuViewOrganizationCard({ memberCount, onInviteMembers, onViewOrganization, orgName }: AccountMenuViewOrganizationCardProps) {
  return (
    <div className="flex flex-col gap-1 px-2 py-3">
      <DropdownMenu.Item
        onSelect={onViewOrganization}
        className="group flex w-full cursor-pointer items-center rounded px-2 py-0 text-left focus:outline-hidden min-h-10 hover:bg-surface-hover focus:bg-surface-hover data-highlighted:bg-surface-hover"
      >
        <div className="flex min-w-0 flex-1 flex-col justify-center gap-0.5">
          <span className="text-sm font-medium leading-5 tracking-[-0.15px] text-brand-neutral-950">{orgName}</span>
          <span className="truncate text-xs leading-4 text-brand-neutral-600">
            {memberCount} {memberCount === 1 ? 'member' : 'members'}
          </span>
        </div>
        <ChevronRight className="size-4 shrink-0 text-brand-neutral-700" aria-hidden />
      </DropdownMenu.Item>

      {onInviteMembers && (
        <DropdownMenu.Item onSelect={onInviteMembers} className="flex cursor-pointer gap-1 rounded py-0.5 text-left focus:outline-hidden">
          <Button
            variant="plain"
            color="primary"
            size="xs"
            className="justify-start"
            leadingIcon={<AddCollaborator className="size-3.5 shrink-0 text-brand-500" aria-hidden />}
          >
            Invite members
          </Button>
        </DropdownMenu.Item>
      )}
    </div>
  )
}
